import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fx-layout-default',
  templateUrl: './layout-default.component.html'
  // styleUrls: ['./layout-default.component.css']
})
export class FxLayoutDefaultComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
